import { useCallback, useEffect, useRef } from 'react';

import { UserModel } from '../redux/types/user.d';

export interface UseSocketTypes {
  scriptURL: string;
  options?: string | WorkerOptions;
  user: UserModel;
  onMessage: (data: MessageEvent) => void;
}

const useSocket = (props: UseSocketTypes) => {
  const notificationWorkerRef = useRef<SharedWorker | undefined>(undefined);

  const { scriptURL, options, user, onMessage } = props;
  const connectSocket = useCallback(() => {
    setTimeout(() => {
      if (window.SharedWorker) {
        notificationWorkerRef.current = new SharedWorker(scriptURL, options);
        notificationWorkerRef.current.port.onmessage = onMessage;
        notificationWorkerRef.current.port.postMessage(
          `REFRESH_NOTIFICATION,${user.id},${process.env.REACT_APP_API_HOST}`
        );
      }
    }, 1000);
  }, [options, scriptURL, user]);

  const disconnectSocket = () => {
    if (!notificationWorkerRef.current) return;
    notificationWorkerRef.current.port.postMessage('disconnect');
  };

  useEffect(() => {
    if (user) {
      connectSocket();
      window.addEventListener('beforeunload', disconnectSocket);
    }
  }, [connectSocket, user]);

  return {};
};

export default useSocket;
